// extracted by mini-css-extract-plugin
export var tabContainer = "pillTabs-module--tabContainer--mSRMv";
export var active = "pillTabs-module--active--TEf7w";
export var tabContent = "pillTabs-module--tabContent--RYvmr";
export var fadeIn = "pillTabs-module--fadeIn--4SY49";
export var slideIn = "pillTabs-module--slideIn--ZhQHb";